module.exports = __webpack_public_path__ + "static/media/white_logo.b8e4acea.png";